import api from "./api";
import getAuthHeaders from "./get-auth-headers";
import type { TCustomFieldRule } from "@atlas/tool/box/conditional-fields/evaluate";

enum CustomFieldCategory {
  ACCOUNT = "account",
  CUSTOMER = "customer",
  TICKET = "ticket",
}

export enum CustomFieldTypes {
  TEXT = "Text",
  NUMBER = "Number",
  DECIMAL = "Decimal",
  BOOLEAN = "Boolean",
  DATE = "Date",
  LIST = "List",
  MONEY = "Money",
  MULTI_SELECT = "MultiSelect",
  ADDRESS = "Address",
}

export type CustomField = {
  key: string;
  displayName: string;
  category: CustomFieldCategory;
  type: CustomFieldTypes;
  fieldMetadata: Array<string>;
  rules: TCustomFieldRule[];
  dependsOn: string[];
};

export default function loadCustomFields(appId: string) {
  return api<CustomField[]>({
    path: "/customer-portal/custom-fields",
    headers: getAuthHeaders(appId),
  });
}
